import {
  Component,
  inject,
  TemplateRef,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef
} from '@angular/material/snack-bar';
import { ZefErrorTemplateService } from '../../error-template.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'zef-snack-error',
  templateUrl: './snack-error.component.html',
  styleUrls: [ './snack-error.component.scss' ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SnackErrorComponent implements OnInit, OnDestroy {

  #data = inject(MAT_SNACK_BAR_DATA);
  snackRef = inject(MatSnackBarRef<SnackErrorComponent>);
  #errorTemplates = inject(ZefErrorTemplateService);

  tpl: TemplateRef<any>;
  data: any;

  ngOnInit() {
    this.data = this.#data;
    this.tpl = this.#errorTemplates.getTemplate('snack');
  }

  ngOnDestroy() {
    this.close();
  }

  close() {
    if (this.snackRef) {
      this.snackRef.dismissWithAction();
    }
  }
}
